const blogThemesContainer = document.querySelector('.sub-category-container');
const subCategoryButtons = document.querySelectorAll('.sub-category-outer-box');
const preferences = JSON.parse(localStorage.getItem("userPreferences")) || []; 
const isSiuBlogUrlMatch = window.location.pathname.match(/\/blogs\/(\d+)-month\/?$/);
const blogMonthContainer = document.querySelector('.blog-category__wrapper');
const selectedBlogMonth = document.querySelector('.selected-main-category');
const blogMonth = getBlogMonth();
if(subCategoryButtons.length > 0){
  subCategoryButtons.forEach(button => {
    button.addEventListener('click', switchTab);
  });
}

// Function to find and click the matching category
function selectPreferredCategory() {
  if (!blogMonth) return; 

  let selectedButton = null;

  // Loop through buttons to find a matching preference
  subCategoryButtons.forEach(button => {
    if (preferences.length > 0) {
      const matchingPreference = preferences.find(pref => pref.month === blogMonth);
      if (matchingPreference && button.dataset.subCategoryId === matchingPreference.theme) {
        selectedButton = button;
      }
    }
  });

  // If no match found, select the default category with 'order-0' class
  if (!selectedButton) {
    selectedButton = document.querySelector('.order-0');
  }

  // Click the selected button if it exists
  if (selectedButton) {
    selectedButton.click();
  }
}


function getBlogMonth() {
  if (isSiuBlogUrlMatch) {
    const month = parseInt(isSiuBlogUrlMatch[1], 10);
    if (month >= 5 && month <= 12) {
      return `${month}-month`;
    }
  }
  return null;
}

function updateUserPreferences(selectedCategory) {
  const monthValue = getBlogMonth();
  if (!monthValue) return;

  // Check if the month already exists and update its theme
  const existingIndex = preferences.findIndex(item => item.month === monthValue);
  if (existingIndex !== -1) {
    preferences[existingIndex].theme = selectedCategory;
  } else {
    // Add new entry for the month
    preferences.push({ month: monthValue, theme: selectedCategory });
  }

  // Save updated preferences
  localStorage.setItem("userPreferences", JSON.stringify(preferences));
}

function switchTab(event) {
  if (!event || !event.currentTarget) {
      return;
  }
  const selectedCategory = event.currentTarget.dataset.subCategoryId;
  // Remove active-category class from all buttons, including .order-0
  subCategoryButtons.forEach(button => {
    button.classList.remove('active-category');
  });

  // Add active-category class to the clicked button
  event.currentTarget.classList.add('active-category');
  

  // Hide all articles
  const articles = document.querySelectorAll('.concern-category__article');
  if(articles.length > 0){
    articles.forEach(article => {
      article.classList.add('d-none');
    });
  }

  const matchingArticles = document.querySelectorAll(`.concern-category__article[data-tag="${selectedCategory}"]`);
  matchingArticles.forEach(article => {
    article.classList.remove('d-none');
  });
  if(blogThemesContainer && event.currentTarget){
    scrollToSelectedElement(blogThemesContainer, event.currentTarget);
  }
  if(selectedCategory){
    updateUserPreferences(selectedCategory);
  }
}

  
  const mainCategoryParent = document.querySelector('.blog-concern-blog-list .blog-category__wrapper');
  mainCategoryParent?.classList.add(mainCategoryParent.children.length > 6 ? 'desktop-justify-start' : 'desktop-justify-center');

  const subCategoryParent = document.querySelector('.sub-category-container');
  subCategoryParent?.classList.add(subCategoryParent.children.length > 4 ? 'desktop-justify-start' : 'desktop-justify-center');


  function scrollToSelectedElement(container, selectedElement) {
    if (!container || !selectedElement) {
      return;
    }
    
    const selectedElementRect = selectedElement.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();
  
    const scrollPosition = container.scrollLeft + (selectedElementRect.left - containerRect.left) - (container.offsetWidth / 2) + (selectedElement.offsetWidth / 2);
  
    container.scrollTo({
      left: scrollPosition,
      behavior: 'smooth'
    });
  }
  


  window.addEventListener('DOMContentLoaded', ()=> {
    if(subCategoryButtons.length > 0){
      selectPreferredCategory();
    }
    if(blogMonthContainer && selectedBlogMonth){  
      scrollToSelectedElement(blogMonthContainer, selectedBlogMonth);
    }
    const articleThemeElement = document.querySelector('.blog-theme-name');
    const articleThemeName = articleThemeElement?.dataset?.blogTheme;
    if(articleThemeElement){
      articleThemeElement.addEventListener('click', ()=>{
        if(articleThemeName){
          updateUserPreferences(articleThemeName)
        }
      });
    }
  });

//====================== Meal Plan javascript ======================

  const selectWeekEle = document.querySelector('.selected-weeks__container');
  const selectWeekDayEle = document.querySelector('.selected-day__container');
  const mealPlanWeekContainer = document.querySelector('.selected-week__container');
  const mealPlanDayContainer = document.querySelector('.selected-week-day__container');
  const bodyEle = document.querySelector('body');
  const overlayEle = document.querySelector('.mm-ajaxcart-overlay');


  const mealWeekInput = document.querySelectorAll('.dropdown-week-item__container .meal-week__input');
  const selectedWeek = document.querySelector('.selected-week--name');
  const defaultSelectedWeek = document.querySelector('.selected-meal--week');

  mealWeekInput?.forEach(eachinput => {
    eachinput.addEventListener('click', () => {
      const eachValue = eachinput.value;

      let eachWeekName = eachValue.replace(/-/g, ' ');
      eachWeekName = eachWeekName.charAt(0).toUpperCase() + eachWeekName.slice(1);

      // Update the selected week and default selected week elements
      selectedWeek.innerHTML = eachWeekName;
      defaultSelectedWeek.innerHTML = eachWeekName;
      const selectDays = document.querySelectorAll('.dropdown-day-item__container')
      selectDays?.forEach(eachDay => {
        eachDay.style.display = 'none'
        eachDay.classList.remove('show-day-dropdown')
      })
      const selectedDaysContainer = document.querySelector(`[data-week=${eachValue}]`);
      selectedDaysContainer.style.display = 'block'
      selectedDaysContainer.classList.add('show-day-dropdown')
    })
  })

  const mealDayInput = document.querySelectorAll('.meal-day__input');
  const selectedDay = document.querySelector('.selected-week--day');
  const defaultSelectedDay = document.querySelector('.selected-meal--day')
  mealDayInput?.forEach(eachDayInput => {
    eachDayInput.addEventListener('click', () => {
      const eachDayValue = eachDayInput.value.trim();
      const day = eachDayValue.split('-').pop(); 

      // Update the selected day and default selected day elements
      selectedDay.innerHTML = day;
      defaultSelectedDay.innerHTML = day;
      const selectDaysData = document.querySelectorAll('.slurrpitup-meal__content')
      selectDaysData?.forEach(eachData => {
        eachData.style.display = 'none'
      })
      const selectedDataContainer = document.querySelector(`#${eachDayValue}`);
      selectedDataContainer.style.display = 'block'
    })
  })
  
  function handleWeekDropdown() {
    if (!mealPlanWeekContainer.classList.contains('show-day-dropdown')) {
      mealPlanWeekContainer.classList.add('show-day-dropdown');
      bodyEle.classList.add('no-scroll');
      overlayEle.classList.add('overlay-active');
    }
  }
  function closeWeekDropdown() {
    mealPlanWeekContainer?.classList.remove('show-day-dropdown');
    bodyEle.classList.remove('no-scroll');
    overlayEle.classList.remove('overlay-active');
  }

// weeks dropdown open and closeing
const dropdownWeekItems = document.querySelectorAll('.dropdown-week-list__items');
selectWeekEle?.addEventListener('click', () => {
  event.stopPropagation();
  handleWeekDropdown()
})

document.addEventListener('click', (event) => {
  if (!mealPlanWeekContainer?.contains(event.target) && !selectWeekEle?.contains(event.target)) {
    closeWeekDropdown()
  }
});

const selectAgeWeekDropdown = document.querySelector('.selected-meal-week');
if (selectAgeWeekDropdown) {
  selectAgeWeekDropdown.addEventListener('click', (event) => {
    event.stopPropagation();
    closeWeekDropdown()
  });
}

dropdownWeekItems.forEach(eachItem => {
  eachItem.addEventListener('click', () => {
    closeWeekDropdown()
    event.stopPropagation();
  })
})

//  days dropdown open and closing
function handleDayDropdown() {
  if (!mealPlanDayContainer.classList.contains('show-day-dropdown')) {
    mealPlanDayContainer.classList.add('show-day-dropdown');
    bodyEle.classList.add('no-scroll');
    overlayEle.classList.add('overlay-active');
  }
}

function closeDayDropdown() {
  mealPlanDayContainer?.classList.remove('show-day-dropdown');
  bodyEle.classList.remove('no-scroll');
  overlayEle.classList.remove('overlay-active');
}

const dropdownDaysItems = document.querySelectorAll('.dropdown-list__items');
selectWeekDayEle?.addEventListener('click', () => {
  event.stopPropagation();
  handleDayDropdown();
})

document.addEventListener('click', (event) => {
  if (!mealPlanDayContainer?.contains(event.target) && !selectWeekDayEle?.contains(event.target)) {
    closeDayDropdown();
  }
});

const selectAgeDayDropdown = document.querySelector('.selected-meal-day');
if (selectAgeDayDropdown) {
  selectAgeDayDropdown.addEventListener('click', (event) => {
    event.stopPropagation();
    closeDayDropdown();
  });
}

dropdownDaysItems.forEach(eachItem => {
  eachItem.addEventListener('click', () => {
    closeDayDropdown();
    event.stopPropagation();
  })
})

// Select the first week and day by default
if (mealWeekInput.length > 0) {
  const firstWeekInput = mealWeekInput[0];
  firstWeekInput.click(); 
}

if (mealDayInput.length > 0) {
  const firstDayInput = mealDayInput[0];
  firstDayInput.click();
}
